// Offers & Payments  form config

export const strategiesFields = [
    {
        key: 'strategy-deployment',
        name: 'Strategy Deployment',
        fields: [
            {
                name: 'strategy_deployed',
                label: 'Strategy Deployed?',
                type: 'text',
                validation: {},
            },
            {
                name: 'company_car',
                label: 'Company Car?',
                type: 'text',
                validation: {},
            },
            {
                name: 'intervention',
                label: 'Intervention?',
                type: 'text',
                validation: {},
            },
            {
                name: 'failure_to_utilise_own_comp_policy',
                label: 'Failure to Utilise Own Comp Policy',
                type: 'text',
                validation: {},
            },
            {
                name: 'basic_hire_rate',
                label: 'Basic Hire Rate?',
                type: 'text',
                validation: {},
            },
            {
                name: 'rw_total_loss',
                label: 'RW Total Loss?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'holiday',
                label: 'Holiday?',
                type: 'date',
                validation: {},
            },
            {
                name: 'fraud_check_date',
                label: 'Fraud Check Date',
                type: 'date',
                validation: [{ name: 'required' }],
            },
            {
                name: 'fraud_check_is_fraud',
                label: 'Fraud result - Is fraud?',
                type: 'boolean',
                validation: [{ name: 'required' }],
            },
            {
                name: 'fraud_check_result',
                label: 'Fraud Check Result',
                type: 'text',
                validation: [{ name: 'required' }],
            },
            {
                name: 'other',
                label: 'Other?',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'savings-reasons',
        name: 'Savings Reasons',
        fields: [
            {
                name: 'period_early_on_hire_driveable_vehicle',
                label: 'Period - Early On Hire - Driveable Vehicle',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_driveable_vehicle',
                label: 'Number of Days Saved - Driveable Vehicle',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_driveable_vehicle',
                label: 'Value of Days Saved - Driveable Vehicle',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_driveable_vehicle',
                label: 'Justification - Driveable Vehicle',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_early_on_hire_driveable_early_bid',
                label: 'Period - Early On Hire - Driveable Early BID',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_driveable_early_bid',
                label: 'Number of Days Saved - Driveable Early BID',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_driveable_early_bid',
                label: 'Value of Days Saved - Driveable Early BID',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_driveable_early_bid',
                label: 'Justification - Driveable Early BID',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_instructing_engineer',
                label: 'Period - Delay in Instructing Engineer',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_instructing_engineer',
                label: 'Number of Days Saved - Instructing Engineer',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_instructing_engineer',
                label: 'Value of Days Saved - Instructing Engineer',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_instructing_engineer',
                label: 'Justification - Instructing Engineer',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_inspection',
                label: 'Period - Delay in Inspection',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_inspection',
                label: 'Number of Days Saved - Delay in Inspection',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_inspection',
                label: 'Value of Days Saved - Delay in Inspection',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_inspection',
                label: 'Justification - Delay in Inspection',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_authority',
                label: 'Period - Delay in Authority',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_authority',
                label: 'Number of Days Saved - Delay in Authority',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_authority',
                label: 'Value of Days Saved - Delay in Authority',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_authority',
                label: 'Justification - Delay in Authority',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_issuing_eng_report_cho',
                label: 'Period - Delay in Issuing Engineers Report to CHO',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_issuing_eng_report_cho',
                label: 'Number of Days Saved - Delay in Issuing Engineers Report to CHO',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_issuing_eng_report_cho',
                label: 'Value of Days Saved - Delay in Issuing Engineers Report to CHO',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_issuing_eng_report_cho',
                label: 'Justification - Delay in Issuing Engineers Report to CHO',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_issuing_eng_report_insurer',
                label: 'Period - Delay in Issuing Engineers Report to Insurer/ Handling Agent',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_issuing_eng_report_insurer',
                label: 'Number of Days Saved - Delay in Issuing Engineers Report to Insurer',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_issuing_eng_report_insurer',
                label: 'Value of Days Saved - Delay in Issuing Engineers Report to Insurer',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_issuing_eng_report_insurer',
                label: 'Justification - Delay in Issuing Engineers Report to Insurer',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_off_hire_post_repair',
                label: 'Period - Delay In Off Hire Post Repair Completion',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_off_hire_post_repair',
                label: 'Number of Days Saved - Delay In Off Hire Post Repair Completion',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_off_hire_post_repair',
                label: 'Value of Days Saved - Delay In Off Hire Post Repair Completion',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_off_hire_post_repair',
                label: 'Justification - Delay In Off Hire Post Repair Completion',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_result_from_rectification',
                label: 'Period - Delays Resultant from Rectification Work',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_result_from_rectification',
                label: 'Number of Days Saved - Delays Resultant from Rectification Work',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_result_from_rectification',
                label: 'Value of Days Saved - Delays Resultant from Rectification Work',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_result_from_rectification',
                label: 'Justification - Delays Resultant from Rectification Work',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_supplementary_authority',
                label: 'Period - Delays in Supplementary Authority',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_supplementary_authority',
                label: 'Number of Days Saved - Delays in Supplementary Authority',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_supplementary_authority',
                label: 'Value of Days Saved - Delays in Supplementary Authority',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_supplementary_authority',
                label: 'Justification - Delays in Supplementary Authority',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_claimant_accepting_pav',
                label: 'Period - Delay in Claimant Accepting PAV Offer',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_claimant_accepting_pav',
                label: 'Number of Days Saved - Delay in Claimant Accepting PAV Offer',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_claimant_accepting_pav',
                label: 'Value of Days Saved - Delay in Claimant Accepting PAV Offer',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_claimant_accepting_pav',
                label: 'Justification - Delay in Claimant Accepting PAV Offer',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_claimant_providing_doc',
                label: 'Period - Delay in Claimant Providing Documentation.',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_claimant_providing_doc',
                label: 'Number of Days Saved  - Delay in Claimant Providing Documentation.',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_claimant_providing_doc',
                label: 'Value of Days Saved - Delay in Claimant Providing Documentation.',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_claimant_providing_doc',
                label: 'Justification - Delay in Claimant Providing Documentation.',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_over_7_days_pav',
                label: 'Period - Delay Over 7 Days Post Receipt of PAV',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_over_7_days_pav',
                label: 'Number of Days Saved - Delay Over 7 Days Post Receipt of PAV',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_over_7_days_pav',
                label: 'Value of Days Saved - Delay Over 7 Days Post Receipt of PAV',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_over_7_days_pav',
                label: 'Justification - Delay Over 7 Days Post Receipt of PAV',
                type: 'text',
                validation: {},
            },
            {
                name: 'period_delay_revert_fully_comp',
                label: 'Period - Delay in Reverting to Fully Comp Policy',
                type: 'text',
                validation: {},
            },
            {
                name: 'number_of_days_saved_delay_revert_fully_comp',
                label: 'Number of Days Saved - Delay in Reverting to Fully Comp Policy',
                type: 'integer',
                validation: {},
            },
            {
                name: 'value_of_days_saved_delay_revert_fully_comp',
                label: 'Value of Days Saved - Delay in Reverting to Fully Comp Policy',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_delay_revert_fully_comp',
                label: 'Justification  - Delay in Reverting to Fully Comp Policy',
                type: 'text',
                validation: {},
            },
            {
                name: 'need_other_vehicle_available_claimant',
                label: 'Need - Other Vehicles Available to Claimant',
                type: 'text',
                validation: {},
            },
            {
                name: 'amount_saved_other_vehicle_available_claimant',
                label: 'Amount Saved  - Other Vehicles Available to Claimant',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_other_vehicle_available_claimant',
                label: 'Justification  - Other Vehicles Available to Claimant',
                type: 'text',
                validation: {},
            },
            {
                name: 'need_company_vehicle',
                label: 'Need - Company Vehicle',
                type: 'text',
                validation: {},
            },
            {
                name: 'amount_saved_company_vehicle',
                label: 'Amount Saved - Company Vehicle',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_company_vehicle',
                label: 'Justification - Company Vehicle',
                type: 'text',
                validation: {},
            },
            {
                name: 'need_roadworthy_total_loss',
                label: 'Need - Roadworthy Total Loss',
                type: 'text',
                validation: {},
            },
            {
                name: 'amount_saved_roadworthy_total_loss',
                label: 'Amount Saved  - Roadworthy Total Loss',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_roadworthy_total_loss',
                label: 'Justification  - Roadworthy Total Loss',
                type: 'text',
                validation: {},
            },
            {
                name: 'need_holiday_non_use',
                label: 'Need - Holiday/ Period of Non Use.',
                type: 'text',
                validation: {},
            },
            {
                name: 'amount_saved_holiday_non_use',
                label: 'Amount Saved - Holiday/ Period of Non Use.',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_holiday_non_use',
                label: 'Justification - Holiday/ Period of Non Use.',
                type: 'text',
                validation: {},
            },
            {
                name: 'rate_incorrect_vehicle_provided_same',
                label: 'Rate - Incorrect Vehicle Provided - Same Banding',
                type: 'text',
                validation: {},
            },
            {
                name: 'amount_saved_incorrect_vehicle_provided_same',
                label: 'Amount Saved - Incorrect Vehicle Provided - Same Banding',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_incorrect_vehicle_provided_same',
                label: 'Justification - Incorrect Vehicle Provided - Same Banding',
                type: 'text',
                validation: {},
            },
            {
                name: 'rate_incorrect_vehicle_provided_different',
                label: 'Rate - Incorrect Vehicle Provided - Different Banding',
                type: 'text',
                validation: {},
            },
            {
                name: 'amount_saved_incorrect_vehicle_provided_different',
                label: 'Amount Saved - Incorrect Vehicle Provided - Different Banding',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_incorrect_vehicle_provided_different',
                label: 'Justification - Incorrect Vehicle Provided - Different Banding',
                type: 'text',
                validation: {},
            },
            {
                name: 'rate_settled_at_basic_hire_rate',
                label: 'Rate - Settled at  Intervention Rate',
                type: 'text',
                validation: {},
            },
            {
                name: 'amount_saved_settled_at_basic_hire_rate',
                label: 'Amount Saved - Settled at  Intervention Rate',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_settled_at_basic_hire_rate',
                label: 'Justification - Settled at  Intervention Rate',
                type: 'text',
                validation: {},
            },
            {
                name: 'rate_settled_at_intervention_rate',
                label: 'Rate - Settled at  Basic Hire Rate',
                type: 'text',
                validation: {},
            },
            {
                name: 'amount_saved_settled_at_intervention_rate',
                label: 'Amount Saved - Settled at  Basic Hire Rate',
                type: 'float',
                validation: {},
            },
            {
                name: 'justification_settled_at_intervention_rate',
                label: 'Justification  - Settled at  Basic Hire Rate',
                type: 'text',
                validation: {},
            },
        ],
    },
];
